module.exports = __webpack_public_path__ + "img/阿魏.6e56e311.jpg";